import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleDotRoundFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5c.95 0 1.902.079 2.799.251-.144.428-.2.86-.2 1.249 0 .708.176 1.566.763 2.271.625.75 1.552 1.13 2.638 1.13.718 0 1.365-.168 1.902-.497Q16 5.397 16 5.955c0 3.195-3.568 5.778-6.44 7.855l-.827.601c-.518.38-.994.744-1.399 1.089v-4.103C3.568 11.249 0 9.817 0 5.954 0 1.865 4 .5 8 .5M4.666 6.7h6.665V5.298H4.666z"
                    fill="currentColor"
                />
                <path d="M14 0c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
            </g>
        </g>
    </svg>
));
BubbleDotRoundFilledSize16Glyph.displayName = 'BubbleDotRoundFilledSize16Glyph';
